import { render, staticRenderFns } from "./MenuMaster.vue?vue&type=template&id=8d225700&"
import script from "./MenuMaster.vue?vue&type=script&lang=js&"
export * from "./MenuMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports